module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"fast-rewind":"Au début","goto-previous-timestamp":"Précédent","goto-next-timestamp":"Suivant","fast-forward":"A la fin"},"de":{}}')
  delete Component.options._Ctor
}
